import axios from '../../utils/axios'
import { API_BASE_URL } from '../../constants'

export const getHPOFromClinicalHistory = async (clinicalHistory) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/hpo-from-clinical-history/`, {
      clinical_history: clinicalHistory,
    })
    return response.data
  } catch (error) {
    console.error('Error fetching HPO suggestions:', error)
    throw error
  }
}
